import React from "react";
import { useHistory } from "react-router-dom";
import {
  List,
  ListItem,
  Typography,
  // ListItemSecondaryAction,
} from "@material-ui/core";
import { Icon } from "../../components";

import { useListStyle, SearchRecommendItem, MuiTypography } from "./style";
import { IAutoCompleteList } from "../../store/searchStoreTypes";
// import { TranslationJSX } from "../../utils/Translation";
import { useStore } from "../../store";
import firebaseEvent from "../../utils/firebaseEvent";
import { setSelectType, setSearchList } from "../../utils/storage";
interface Props {
  isEmpty: boolean;
  list: IAutoCompleteList[];
  type: "hashtag" | "title";
}

const SearchRecommendTagList = ({ list, isEmpty, type }: Props) => {
  const history = useHistory();
  const classes = useListStyle();
  const {
    searchStore: { onUpdateCurrentSearch },
  } = useStore();

  const onClickItem = (tag: any) => {
    const searchValue = type === "hashtag" ? `#${tag}` : tag;
    setSearchList(searchValue);
    setSelectType("search");
    //Firebase Event
    const inputValue = document.getElementsByTagName("input")[0].value;
    onUpdateCurrentSearch({ inputValue, searchValue });
    const jsonParams = {
      P1: searchValue,
      P2: inputValue,
    };
    firebaseEvent("search_keyword", jsonParams);

    const encodeTag = searchValue.includes("%")
      ? encodeURIComponent(searchValue.replace(/%/gi, "percent2e5"))
      : encodeURIComponent(searchValue);
    return history.push(`/search/${encodeTag}`);
  };

  if (isEmpty) {
    return (
      <List className={classes.root}>
        <ListItem className={classes.emptyItem}>
          <Typography variant="body2" color="inherit">
            {/* 검색결과 없음 제거로 인한 제거 */}
            {/* <TranslationJSX locoKey="feed_search_no_result" /> */}
          </Typography>
        </ListItem>
      </List>
    );
  }

  return (
    <List className={classes.root}>
      {list.map((el) => (
        <ListItem
          key={el.title ? el.title : `#${el.hashTagName}`}
          className={classes.item}
          onClick={() => onClickItem(el.title ? el.title : el.hashTagName)}
          button
        >
          <MuiTypography variant="body2" color="inherit">
            <SearchRecommendItem>
              <Icon name="search" size={20} />
              {type === "hashtag" ? "#" : ""}
              {el.title ? el.title : el.hashTagName}
            </SearchRecommendItem>
          </MuiTypography>

          {/* post ui 제거 */}
          {/* <ListItemSecondaryAction className={classes.itemAction}>
            <Typography variant="body2" color="inherit">
              {count} post
            </Typography>
          </ListItemSecondaryAction> */}
        </ListItem>
      ))}
    </List>
  );
};

export default SearchRecommendTagList;
